import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { doctorList, fetchStoreExpenditure, getUpdateStore, storeTypeList } from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const StoreOwner = () => {
  const [storeOwner, setStoreOwner] = useState([]);
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const navigate=useNavigate();
    const [storeExpen,setStoreExpen]=useState([])
    const [modal,setModal]=useState(null)
    const[editModal,setEditModal]=useState(null)

            const [currentPage, setCurrentPage] = useState(1);
          const itemsPerPage = 10;
          
          const indexOfLast = currentPage * itemsPerPage;
          const indexOfFirst = indexOfLast - itemsPerPage;
          
          const currentUsers = storeOwner.slice(indexOfFirst, indexOfLast);


     const handlegetStoreExpenditure=async()=>{
        try {
          const response=await fetchStoreExpenditure(token)
          console.log("handlegetStoreExpenditure",response);
          if(response.status===200){
            setStoreExpen(response.data)
          }
          
        } catch (error) {
          console.log(error);
          
        }
      }
const fetchStoreOwner = async () => {
      try {
        const response = await storeTypeList(token);
        console.log(response);
        
        setStoreOwner(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };
  useEffect(() => {
    
    handlegetStoreExpenditure()

    fetchStoreOwner()
  }, []);

    const handleCommesionRole = () => {
    navigate("/doctor-commesion");
  };

  const handleEditStore=async()=>{
    try {
      console.log(editModal);
     let data=new FormData()
     data.append("storeOwnerId",editModal.storeOwnerId)
     data.append("storeOwnerGstNumber",editModal.storeOwnerGstNumber)
     data.append("storeName",editModal.storeName)
     data.append("storeAddress",editModal.storeAddress)

      const response=await getUpdateStore(data,token)
      console.log(response);
      if(response.status===200){
        toast.success("Store details updated")
        setEditModal(null)
        fetchStoreOwner()
      }
      
      
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong")
      
    }
  }

const handleChange = (e) => {
  const { name, value } = e.target;
  setEditModal(prev => ({
    ...prev,
    [name]: value
  }));
};


  return (
    <div id="main_content">
      <Header />
      <div className="page">

       
<Section/>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Store Owner</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Store Owner
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Doctor-all">
               
                {/* <button
                    onClick={() => handleCommesionRole()}
                    className="btn btn-primary"
                    style={{float:"right"}}
                  >
                   Commision
                  </button> */}

                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{textAlign:"center"}}>ID</th>
                        <th style={{textAlign:"center"}}>StoreName</th>
                        <th style={{textAlign:"center"}}>GST Number</th>
                        <th style={{textAlign:"center"}}>Address</th>
                        <th style={{textAlign:"center"}}>Status</th>
                        <th style={{textAlign:"center"}}>Expendeture</th>
                        <th>Edit</th>
                       
                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers.map((doctor,ind) => (
                         <tr key={doctor.id}>
                         <td>{indexOfFirst+ind+1}</td>
                         <td>
                           {doctor.storeName} 
                         </td>
                         <td>{doctor.storeOwnerGstNumber}</td>
                         <td>{doctor.storeAddress}</td>
                         <td>{doctor.status}</td>
                         <td>
                          <button onClick={()=>setModal(doctor)}
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>

                                 
                         </td>
                         <td> <button onClick={()=>setEditModal(doctor)}
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button></td>
                         
                         
                        
                     
                       </tr>
                      ))}
                    </tbody>
                  </table>
                   <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(storeOwner.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(storeOwner.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>

                {
                  modal && 
                  <div style={{position:"absolute",zIndex:999,backgroundColor:"white",width:"50vw",right:"100px",height:"50vh",top:"80px",padding:"20px",maxHeight:"50vh",overflowY:"auto",border:"0.5px solid gray",borderRadius:"10px"}}>
                 <p onClick={()=>setModal(null)}
                 style={{fontSize:'15px',cursor:"pointer",position:"absolute",top:"10px",right:"10px"}}>X</p>
                 {
                  storeExpen.filter(i=>i.storeId===modal.id).length>0?<div>
                    { storeExpen.filter(i=>i.storeId===modal.id).map((item,ind)=>
                  <div style={{margin:"5px",borderLeft:"4px solid red",padding:"5px"}}> 
                    <p style={{fontSize:"20px",fontWeight:"700"}}>{item.storeName}<span style={{fontSize:'14px'}}>({item.storeTypeName})</span></p>
                    <p style={{fontSize:"16px",fontWeight:"700",color:"gray"}}>Store person :{item.personName}{"   "}<span style={{fontSize:"12px",fontWeight:"700",color:'#2f3653ff'}}>Contact:{item.personContact}</span></p>
                    <p style={{fontSize:"14px",fontWeight:"700",display:"flex",gap:"10px"}}>Expenditure Amount:{item.amount}<span style={{fontSize:"14px",fontWeight:"700"}}>Description:{item.description}</span><span style={{fontSize:"14px",fontWeight:"700"}}> Purpose:{item.purpose}</span></p>
                    <p>Date:{item.expenditureDate[2]}/{item.expenditureDate[1]}/{item.expenditureDate[0]}</p>
                    </div>
                )
                   
                    }
                  </div>:
                  <div>
                    No Expenditure list to show
                    </div>
                 }
                  
                    </div>
                }

                 {
                  editModal && 
                  <div style={{position:"absolute",zIndex:999,backgroundColor:"white",width:"50vw",right:"100px",height:"50vh",top:"80px",padding:"20px",maxHeight:"50vh",overflowY:"auto",border:"0.5px solid gray",borderRadius:"10px"}}>
                 <p onClick={()=>setEditModal(null)}
                 style={{fontSize:'15px',cursor:"pointer",position:"absolute",top:"10px",right:"10px"}}>X</p>

                <div style={{display:"flex",flexDirection:"column",gap:"10px"}}> 
                 <label>Store Name
                 <input name="storeName" value={editModal.storeName}  onChange={handleChange}/></label>
                 <label>GST Number
                 <input name="storeOwnerGstNumber" value={editModal.storeOwnerGstNumber} onChange={handleChange}/></label>
                 <label>Address
                 <input name="storeAddress" value={editModal.storeAddress} onChange={handleChange}/></label>

                 <button onClick={handleEditStore}
                 style={{padding:"8px",borderRadius:"5px",backgroundColor:"#0d81ecff",}}
                 >Edit</button>
                 </div>
                  
                    </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default StoreOwner;
